<template>
  <div class="flex">
    <div
    style="padding: 0;"
      class="PageContainer group-tree_wrapper"
    >
      <GroupTree ref="groupTreeRef" :contentHeight="contentHeight" />
    </div>
    <div
      class="PageContainer user-table_wrapper"
    >
      <UserTable :current-row="currentRow" @reloadTree="reloadTree" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import UserTable from "./components/UserTable/index.vue";
import GroupTree from "./components/GroupTree/index.vue";

export default {
  name: "production-productionLineGroup",
  components: {
    UserTable,
    GroupTree,
  },
  data() {
    return {
      currentRow: {},
      contentHeight: 600,
    };
  },
  provide() {
    return {
      "group-current-row": Vue.observable({
        currentRow: this.currentRow,
        setCurrentRow: (row) => (this.currentRow = row),
      }),
      "group-content-height": Vue.observable({
        contentHeight: this.contentHeight,
        setContentHeight: (height) => (this.contentHeight = height),
      }),
    };
  },
  methods: {
    reloadTree () {
      this.$refs.groupTreeRef.loadData()
    }
  }
};
</script>
<style lang="scss" scoped>
.flex {
    display: flex;
}
.group-tree_wrapper {
    margin-right: 10px;
    min-width: 320px;
    max-width: 320px;
}
.user-table_wrapper {
    flex: 1;
    min-width: 500px;
    
}
.PageContainer {
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid #f1f1f4;
    padding: 0 10px;
}

:root {
  --vxe-table-border-color: #f1f1f4;
  --vxe-table-header-font-color: #252f4a;
  --vxe-table-header-background-color: #fff;
}
::v-deep {
  .vxe-table {
    border-top: 1px solid var(--vxe-table-border-color);
  }
  .vxe-toolbar {
    padding: 0;
  }
  .vxe-toolbar .vxe-buttons--wrapper {
    flex: 1;
  }

  .el-card {
    --el-card-border-color: var(--vxe-table-border-color) !important;
  }
}
</style>
